export default "__VITE_ASSET__BpUcU$Mb__"